import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Col, Row} from "reactstrap";

import iconCalendar from "../media/icons/statusbar/calendar.png"
import iconCalendarInProgress from "../media/icons/statusbar/calendar-in-progress.png"
import iconCalendarDone from "../media/icons/statusbar/calendar-done.png"

import iconPackage from "../media/icons/statusbar/package.png"
import iconPackageOpened from "../media/icons/statusbar/package-opened.png"
import {isMobile} from "react-device-detect";

import iconTechnician from "../media/icons/statusbar/technician.png"
import iconOnlineDevices from "../media/icons/statusbar/online-devices.png"
import {STAGES} from "../pages/Stage";


class StatusBar extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        let customerWillGetAPackage = true;
        if(this.props.customerWillGetAPackage === false){
            customerWillGetAPackage = false;
        }

        let technicianAppointmentRequired = true;
        if(this.props.technicianAppointmentRequired === false){
            technicianAppointmentRequired = false;
        }

        let calendarIcon = <img src={iconCalendar} style={{width:"40px", height:"40px"}} alt={"icon calendar"} />;
        let progressLine1 = <div className={"statusbar-line-done"} />;
        let progressLine2 = <div className={"statusbar-line-done"} />;
        let progressLine3 = <div className={"statusbar-line-done"} />;
        let packageIcon = <img src={iconPackage} style={{width:"40px", height:"40px"}} alt={"icon package"} />;
        let progressLine4 = <div className={"statusbar-line-done"} />;
        let technicianIcon = <img src={iconTechnician} style={{width:"40px", height:"40px"}} alt={"icon technician"}/>;
        let onlineDevicesIcon = <img src={iconOnlineDevices} style={{width:"40px", height:"40px"}} alt={"icon online devices"} />;

        const currentStage = this.props.currentStage;
        if(currentStage >= 1){
            calendarIcon = <img src={iconCalendar} style={{width:"40px", height:"40px"}} alt={"icon calendar"} />;
            progressLine1 = <div className={"statusbar-line"} />;
            progressLine2 = <div className={"statusbar-line"} />;
            progressLine3 = <div className={"statusbar-line"} />;
            packageIcon = <img src={iconPackage} style={{width:"40px", height:"40px",opacity:"0.25"}} alt={"icon packed opacity"} />;
            progressLine4 = <div className={"statusbar-line"} />;
            technicianIcon = <img src={iconTechnician} style={{width:"40px", height:"40px",opacity:"0.25"}} alt={"icon technician opacity"} />;
            onlineDevicesIcon = <img src={iconOnlineDevices} style={{width:"40px", height:"40px",opacity:"0.25"}} alt={"icon online devices opacity"} />;
        }

        if(currentStage >= STAGES.CURRENT_STATUS){
            calendarIcon = <img src={iconCalendarInProgress} style={{width:"40px", height:"40px"}} alt={"icon calendar progress"}/>;
        }
        if(currentStage >= STAGES.CONFIRM_APPOINTMENT){
            calendarIcon = <img src={iconCalendarDone} style={{width:"40px", height:"40px"}} alt={"icon calendar done"} />;
            progressLine1 = <div className={"statusbar-line-done"} />;
        }
        if(currentStage >= STAGES.WAITING_FOR_APPOINTMENT){
            progressLine2 = <div className={"statusbar-line-done"} />;
        }
        if(currentStage >= STAGES.APPOINTMENT_DAY){
            technicianIcon = <img src={iconTechnician} style={{width:"40px", height:"40px",opacity:"1"}} alt={"icon technician"}/>;
            progressLine3 = <div className={"statusbar-line-done"} />;
            packageIcon = <img src={iconPackage} style={{width:"40px", height:"40px",opacity:"1"}} alt={"icon package"} />;
            progressLine4 = <div className={"statusbar-line-done"} />;
        }
        if(currentStage >= STAGES.ROUTER_SETUP){
            packageIcon = <img src={iconPackageOpened} style={{width:"40px", height:"40px"}} alt={"icon package opened"} />;
            onlineDevicesIcon = <img src={iconOnlineDevices} style={{width:"40px", height:"40px",opacity:"1"}} alt={"icon online devices"}/>;
        }
        if(currentStage >= STAGES.SUCCESS){
            onlineDevicesIcon = <img src={iconOnlineDevices} style={{width:"40px", height:"40px",opacity:"1"}} alt={"icon online devices"}/>;
        }

        let packageIconClass = "";
        if(!customerWillGetAPackage){
            packageIcon = <div className={"statusbar-line"} style={{opacity:"1"}}/>;
            packageIconClass = "statusbar-line-col"
        }

        let technicianIconColClass = "";
        if(!technicianAppointmentRequired){
            technicianIcon = <div className={"statusbar-line"} />;
            technicianIconColClass = "statusbar-line-col"
        }

        let description = "";
        if(this.props.showDescription === true){
            progressLine1 = <div className={"statusbar-line"} />;
            progressLine2 = <div className={"statusbar-line"} />;
            progressLine3 = <div className={"statusbar-line"} />;
            progressLine4 = <div className={"statusbar-line"} />;

            if(!isMobile){
                progressLine1 = <div className={"statusbar-line-min"} />;
                progressLine4 = <div className={"statusbar-line-min"} />;
            }


            description = <Row style={{marginTop:"10px"}}>
                <Col xs={5} md={{size:4}}>
                    <div className={'text-statusbar-number'}>1</div>
                    {i18n.t("select_technician_appointment")}
                </Col>

                <Col xs={3} md={{size:2,offset:3}}>
                    <div className={'text-statusbar-number'}>2</div>
                    {i18n.t("receive_router")}
                </Col>

                <Col xs={4} md={{size:2,offset:1}}>
                    <div className={'text-statusbar-number'}>3</div>
                    {i18n.t("receive_clearing")}
                </Col>
            </Row>
        }

        const dynamicBar = <div>
            <Row style={{paddingTop:"15px"}}>
                <Col xs={2} md={1}>
                    {calendarIcon}
                </Col>
                <Col xs={1} md={2} className={"statusbar-line-col"}>
                    {progressLine1}
                </Col>
                <Col xs={1} md={2} className={"statusbar-line-col"}>
                    {progressLine2}
                </Col>
                <Col xs={1} md={2} className={"statusbar-line-col"}>
                    {progressLine3}
                </Col>
                <Col xs={2} md={1} className={packageIconClass}>
                    {packageIcon}
                </Col>
                <Col xs={1} md={2} className={"statusbar-line-col"}>
                    {progressLine4}
                </Col>
                <Col xs={2} md={1} className={technicianIconColClass}>
                    {technicianIcon}
                </Col>
                <Col xs={2} md={1}>
                    {onlineDevicesIcon}
                </Col>
            </Row>
            {description}
        </div>;

        return dynamicBar
    }
}

export default translate("translations")(StatusBar);
